<teleport to="body">
    <Modal
        @on-ok="updateDisplayCompetitorPopup(false)"
        @on-close="updateDisplayCompetitorPopup(false)"
        :buttons="[]"
        class="competitor-products-popup"
    >
        <template v-slot:header>
            <h2 class="d-inline-block mr-1">Конкуренты</h2>
        </template>
        <template v-slot:body>
            <div class="competitor-products-container">
                <table>
                    <tr v-for="competitorProduct in sortedProducts">
                        <td>
                            <input
                                v-if="selected"
                                type="checkbox"
                                class="compare-product-btn"
                                :checked="Array.isArray(selected[lbrProductId]) && selected[lbrProductId].includes(competitorProduct.id)"
                                @input="toggleSelected(competitorProduct.id)"
                            />
                        </td>
                        <td>
                            <div class="img" :style="{
                                background: `url(${competitorProduct.preview_url}) center / contain no-repeat`,
                            }"></div>
                        </td>
                        <td>
                            <div class="competitor-product-details">
                                <div class="product-name">{{competitorProduct.name}}</div>
                                <div class="product-region">{{competitorProduct.region}}</div>
                            </div>
                        </td>
                        <td>
                            <div class="competitor-product-price" v-if="competitorProduct.prices.min">
                                {{getPriceLabel(competitorProduct.prices)}}
                            </div>
                        </td>
                    </tr>
                </table>
                <div @click="addToCompare" :class="{'competitor-add-to-compare-button': true, 'disabled': false}">
                    Добавить в сравнение
                </div>
            </div>
        </template>
    </Modal>
</teleport>
